module.exports = __webpack_public_path__ + "static/img/3-Social-housing-in-Newport.4e2071a1.jpg";